import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

const device = new URLSearchParams(window.location.search).get('device');
if (device) window.localStorage.setItem('deviceName', device);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
